import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'
export class CorporateNameInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'CorporateName',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.billingInformation.corporateName
  }
}
